import { render, staticRenderFns } from "./ButtonCounter.vue?vue&type=template&id=5cb211bd&"
import script from "./ButtonCounter.vue?vue&type=script&lang=js&"
export * from "./ButtonCounter.vue?vue&type=script&lang=js&"
import style0 from "./ButtonCounter.vue?vue&type=style&index=0&id=5cb211bd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports